import { Input, message, Modal } from "antd";

import React from "react";

import MembersList from "../MembersList";
import ListItem from "./Components/ListItem";
import style from "./index.module.scss";
import {
    CustomEmpty,
    errorMessage,
    ResultMessage,
    setHasRead,
    useModalHandler
} from "../../polyfills";
import useFilterSessionList from "../../Utils/useFilterSessionList";
import useUpdateSession from "../../Utils/useUpdateSession";

const { Search } = Input;

interface LayoutMobileProps {
    onGotoDetail(sessionId: string): void;
}

export default function LayoutMobile({ onGotoDetail }: LayoutMobileProps) {
    const sessionManager = useUpdateSession();
    const membersModal = useModalHandler();

    const { sessionList, setSearchText } = useFilterSessionList();

    function handleReadStatus() {
        const sessionIds = sessionList.map(item => item.guid);

        Modal.confirm({
            content: "消息被标记为已读后将无法恢复，确定执行？",
            onOk: async () => {
                localStorage.setItem("unreadList", JSON.stringify([]));
                try {
                    await setHasRead(sessionIds);

                    sessionIds.forEach(sessionId =>
                        sessionManager.markSessionRead(sessionId as string)
                    );

                    message.success("执行成功");
                } catch (e) {
                    ResultMessage.error(errorMessage(e));
                }
            }
        });
    }

    return (
        <div className={style.root}>
            <div className={style.header}>
                <div
                    role="button"
                    className={style.markRead}
                    onClick={handleReadStatus}>
                    <img
                        src={require("./img/clear.png")}
                        className={style.clearIcon}
                    />
                    标记所有为已读
                </div>
            </div>

            <div className={style.searchWrapper}>
                <Search
                    maxLength={200}
                    allowClear
                    className={style.search}
                    placeholder="请输入联系人姓名或私信关键字"
                    onSearch={value => setSearchText(value)}
                />

                <img
                    src={require("./img/icon.png")}
                    alt=""
                    onClick={membersModal.open}
                />
            </div>

            <div className={style.container}>
                {sessionList?.map(item => (
                    <ListItem
                        key={item.guid}
                        item={item}
                        onGotoDetail={() => onGotoDetail(item.guid)}
                    />
                ))}

                {sessionList.length === 0 && (
                    <CustomEmpty
                        description="暂无聊天"
                        style={{ padding: "100px 0" }}
                    />
                )}
            </div>

            <MembersList
                visible={membersModal.visible}
                onCancel={membersModal.close}
                onSuccess={membersModal.close}
            />
        </div>
    );
}
